import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

import { avgEngagementOnImpressionConfig } from './../avgEngagementOnImpression';

export const mediaViewerEngagementOnImpressionsConfig = {
    ...avgEngagementOnImpressionConfig,
    id: 'engagement_on_impression',
    size: SIZE_50,
    name: 'kpi.linkedin.mediaviewer.engagement_on_impressions',
    tooltip: null,
    loader: MediaViewerKpiLoader
};
